import type { ReactElement } from "react";

import { InclusionFilterResult } from "app/pages/sales-intelligence/common-components/filters-panel/components/InclusionFilterResult/InclusionFilterResult";
import {
    getSiteTagsConditionKey,
    hasSameSiteTagsObject,
} from "app/pages/sales-intelligence/domain/leads/utils/site-tags-operations";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type SiteTagsFilterModel from "../../../models/SiteTagsFilter/SiteTagsFilterModel";
import leadsSearchFiltersTrackingService from "../../../services/tracking/trackingService";

import InclusionSiteTagsChip from "./InclusionSiteTagsChip/InclusionSiteTagsChip";
import { SiteTagsModal } from "./modals/SiteTagsModal/SiteTagsModal";

const SiteTagsFilterResult = ({
    filter,
    value = [],
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<SiteTagsFilterModel>): ReactElement | null => (
    <InclusionFilterResult
        value={value}
        isActionEnabled={isActionEnabled}
        onGetLifecycleStatus={onGetLifecycleStatus}
        onFilterUpdate={onFilterUpdate}
        onFilterValueRemove={onFilterValueRemove}
        hasSameObject={hasSameSiteTagsObject}
        getConditionKey={getSiteTagsConditionKey}
        onDeleteCondition={(selectedItem) => {
            selectedItem.values.forEach((tag) =>
                leadsSearchFiltersTrackingService.filters.trackSiteTagsValueDelete(tag),
            );
        }}
        renderModal={({ isOpen, selectedItem, onClose, onCancel, onApply }) => (
            <SiteTagsModal
                isOpen={isOpen}
                selected={selectedItem}
                value={value}
                isExcludeAvailable={filter.isExcludeInclusionAvailable(value, selectedItem)}
                onClose={onClose}
                onCancel={onCancel}
                onApply={onApply}
            />
        )}
        renderChip={({ item, hideActionButton, onEdit, onDelete }) => (
            <InclusionSiteTagsChip
                item={item}
                hideActionButton={hideActionButton}
                onEdit={onEdit}
                onDelete={onDelete}
            />
        )}
    />
);

export default SiteTagsFilterResult;
